import React, { useEffect, useState } from 'react'
import {
  useMsal,
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from '@azure/msal-react'
import { InteractionStatus } from '@azure/msal-browser'
import { loginRequest } from './msalConfig'
import LoginPage from '../components/auth/LoginPage'

interface AuthProviderProps {
  children: React.ReactNode
}

export function AuthProvider({ children }: AuthProviderProps) {
  const { instance, inProgress } = useMsal()
  const [redirectError, setRedirectError] = useState<string | null>(null)

  useEffect(() => {
    instance.handleRedirectPromise().catch((err: unknown) => {
      const msg = (err as Error)?.message ?? 'Error de autenticación. Intenta de nuevo.'
      setRedirectError(msg)
    })
  }, [instance])

  if (inProgress !== InteractionStatus.None) {
    return (
      <div className="flex h-screen items-center justify-center bg-slate-50 dark:bg-surface-950">
        <p className="animate-pulse text-sm text-gray-500 dark:text-gray-400">
          Autenticando…
        </p>
      </div>
    )
  }

  return (
    <>
      <AuthenticatedTemplate>{children}</AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <LoginPage loginError={redirectError} />
      </UnauthenticatedTemplate>
    </>
  )
}

export function useLogin() {
  const { instance } = useMsal()
  return () => instance.loginRedirect(loginRequest)
}

export function useLogout() {
  const { instance } = useMsal()
  return () =>
    instance.logoutRedirect({ postLogoutRedirectUri: window.location.origin })
}
